/*
import { useWeb3React } from '@web3-react/core';
import { useContext } from 'react';
import useSWR from 'swr';
import { config } from '../../../config/config';
import appContext from '../../../context/app/appContext';
*/

/*
const useLatestProposal = () => {
    const { account } = useWeb3React();

    const { interfaceSDK } = useContext(appContext);

    const { data, error } = useSWR(
        interfaceSDK && account ? 'latestProposal' : null,
        () => {
            if (config.snapshot.PROPOSAL_ID) {
                return interfaceSDK?.get.getProposalById(config.snapshot.PROPOSAL_ID);
            }
            return interfaceSDK!.get.getLastSpoolEmissionsProposal();
        }
    );

    return {
        latestProposal: data,
        isLoading: !error && !data,
        error,
    };
};
*/

const useMockLatestProposal = () => {
    const mockProposal = {
        id: '0x1234567890abcdef',
        title: 'Mock Proposal: Increase Emission Rate',
        description: 'This is a mock proposal for testing purposes',
        state: 'active',
        start: Date.now() - 86400000,
        end: Date.now() + 86400000,
        snapshot: '12345678',
        author: '0xabcdef1234567890abcdef1234567890abcdef12',
        space: { id: 'spool', name: 'Spool DAO' },
        choices: ['Yes', 'No'],
        scores: [1000, 500],
        scores_total: 1500,
    };

    return {
        latestProposal: mockProposal,
        isLoading: false,
        error: null,
    };
};

export default useMockLatestProposal;
